const getAttributeContent = (selector: string, valueName: string) => {
    const content = document.querySelector(selector)?.getAttribute('content');

    if (!content) {
        throw new Error(`Failed to get ${valueName}`);
    }

    return content;
};

export const AUTH_BASE_URL = getAttributeContent('meta[name="auth-base-url"]', 'AUTH_BASE_URL');
